// FETCH ALL PROCESS_COST_PER_KG
export const FETCH_PROCESS_COST_PER_KG_REQUEST = 'FETCH_PROCESS_COST_PER_KG_REQUEST';
export const FETCH_PROCESS_COST_PER_KG_SUCCESS = 'FETCH_PROCESS_COST_PER_KG_SUCCESS';
export const FETCH_PROCESS_COST_PER_KG_FAILURE = 'FETCH_PROCESS_COST_PER_KG_FAILURE';

export const FETCH_PROCESS_FLOW_PER_KG_REQUEST = 'FETCH_PROCESS_FLOW_PER_KG_REQUEST';
export const FETCH_PROCESS_FLOW_PER_KG_SUCCESS = 'FETCH_PROCESS_FLOW_PER_KG_SUCCESS';
export const FETCH_PROCESS_FLOW_PER_KG_FAILURE = 'FETCH_PROCESS_FLOW_PER_KG_FAILURE';

export const FETCH_INSERT_COST_BY_PROCESS_ID_REQUEST = 'FETCH_INSERT_COST_BY_PROCESS_ID_REQUEST';
export const FETCH_INSERT_COST_BY_PROCESS_ID_SUCCESS = 'FETCH_INSERT_COST_BY_PROCESS_ID_SUCCESS';
export const FETCH_INSERT_COST_BY_PROCESS_ID_FAILURE = 'FETCH_INSERT_COST_BY_PROCESS_ID_FAILURE';

export const FETCH_INSERT_COST_BY_PROCESS_ID2_REQUEST = 'FETCH_INSERT_COST_BY_PROCESS_ID2_REQUEST';
export const FETCH_INSERT_COST_BY_PROCESS_ID2_SUCCESS = 'FETCH_INSERT_COST_BY_PROCESS_ID2_SUCCESS';
export const FETCH_INSERT_COST_BY_PROCESS_ID2_FAILURE = 'FETCH_INSERT_COST_BY_PROCESS_ID2_FAILURE';

export const FETCH_CHECK_PROCESS_COST_PER_KG_ADD_ON_REQUEST = 'FETCH_CHECK_PROCESS_COST_PER_KG_ADD_ON_REQUEST';
export const FETCH_CHECK_PROCESS_COST_PER_KG_ADD_ON_SUCCESS = 'FETCH_CHECK_PROCESS_COST_PER_KG_ADD_ON_SUCCESS';
export const FETCH_CHECK_PROCESS_COST_PER_KG_ADD_ON_FAILURE = 'FETCH_CHECK_PROCESS_COST_PER_KG_ADD_ON_FAILURE';

export const FETCH_DELETE_BY_PROCESS_ID_REQUEST = 'FETCH_DELETE_BY_PROCESS_ID_REQUEST';
export const FETCH_DELETE_BY_PROCESS_ID_SUCCESS = 'FETCH_DELETE_BY_PROCESS_ID_SUCCESS';
export const FETCH_DELETE_BY_PROCESS_ID_FAILURE = 'FETCH_DELETE_BY_PROCESS_ID_FAILURE';

export const CHECK_INSERT_COST_BY_PROCESS_ID_REQUEST = 'CHECK_INSERT_COST_BY_PROCESS_ID_REQUEST';
export const CHECK_INSERT_COST_BY_PROCESS_ID_SUCCESS = 'CHECK_INSERT_COST_BY_PROCESS_ID_SUCCESS';
export const CHECK_INSERT_COST_BY_PROCESS_ID_FAILURE = 'CHECK_INSERT_COST_BY_PROCESS_ID_FAILURE';

export const FETCH_CHECK_COST_BY_PROCESS_ID_REQUEST = 'FETCH_CHECK_COST_BY_PROCESS_ID_REQUEST';
export const FETCH_CHECK_COST_BY_PROCESS_ID_SUCCESS = 'FETCH_CHECK_COST_BY_PROCESS_ID_SUCCESS';
export const FETCH_CHECK_COST_BY_PROCESS_ID_FAILURE = 'FETCH_CHECK_COST_BY_PROCESS_ID_FAILURE';

// CREATE PROCESS_COST_PER_KG
export const CREATE_PROCESS_COST_PER_KG_REQUEST = 'CREATE_PROCESS_COST_PER_KG_REQUEST';
export const CREATE_PROCESS_COST_PER_KG_SUCCESS = 'CREATE_PROCESS_COST_PER_KG_SUCCESS';
export const CREATE_PROCESS_COST_PER_KG_FAILURE = 'CREATE_PROCESS_COST_PER_KG_FAILURE';

// UPDATE PROCESS_COST_PER_KG
export const UPDATE_PROCESS_COST_PER_KG_REQUEST = 'UPDATE_PROCESS_COST_PER_KG_REQUEST';
export const UPDATE_PROCESS_COST_PER_KG_SUCCESS = 'UPDATE_PROCESS_COST_PER_KG_SUCCESS';
export const UPDATE_PROCESS_COST_PER_KG_FAILURE = 'UPDATE_PROCESS_COST_PER_KG_FAILURE';

// FETCH SINGLE STATE
export const FETCH_SINGLE_PROCESS_COST_PER_KG_REQUEST = 'FETCH_SINGLE_PROCESS_COST_PER_KG_REQUEST';
export const FETCH_SINGLE_PROCESS_COST_PER_KG_SUCCESS = 'FETCH_SINGLE_PROCESS_COST_PER_KG_SUCCESS';
export const FETCH_SINGLE_PROCESS_COST_PER_KG_FAILURE = 'FETCH_SINGLE_PROCESS_COST_PER_KG_FAILURE';

// DELETE PROCESS_COST_PER_KG
export const DELETE_PROCESS_COST_PER_KG_REQUEST = 'DELETE_PROCESS_COST_PER_KG_REQUEST';
export const DELETE_PROCESS_COST_PER_KG_SUCCESS = 'DELETE_PROCESS_COST_PER_KG_SUCCESS';
export const DELETE_PROCESS_COST_PER_KG_FAILURE = 'DELETE_PROCESS_COST_PER_KG_FAILURE';

// FETCH ALL PROCESS_COST_PER_KG BY STYLE DETAIL ID
export const FETCH_PROCESS_COST_PER_KG_BY_STYLE_DETAIL_ID_REQUEST = 'FETCH_PROCESS_COST_PER_KG_BY_STYLE_DETAIL_ID_REQUEST';
export const FETCH_PROCESS_COST_PER_KG_BY_STYLE_DETAIL_ID_SUCCESS = 'FETCH_PROCESS_COST_PER_KG_BY_STYLE_DETAIL_ID_SUCCESS';
export const FETCH_PROCESS_COST_PER_KG_BY_STYLE_DETAIL_ID_FAILURE = 'FETCH_PROCESS_COST_PER_KG_BY_STYLE_DETAIL_ID_FAILURE';

export const FETCH_PROCESS_COST_PER_KG_BY_STYLE_DETAIL_ID_RESET = 'FETCH_PROCESS_COST_PER_KG_BY_STYLE_DETAIL_ID_RESET';

export const RESET_PROCESS_COST_PER_KG_INFO = 'RESET_PROCESS_COST_PER_KG_INFO';

export const CREATE_PROCESS_COST_PER_KG_FORM = 'CREATE_PROCESS_COST_PER_KG_FORM';

export const UPDATE_PROCESS_COST_PER_KG_FORM = 'UPDATE_PROCESS_COST_PER_KG_FORM';

export const ASSIGN_PROCESS_TOGGLE_KG = 'ASSIGN_PROCESS_TOGGLE_KG';
export const SET_SELECT_PROCESS_VALUE = 'SET_SELECT_PROCESS_VALUE';

//FETCH INVOICE DATA
export const FETCH_PROCESS_COST_PER_KG_INVOICE_REQUEST = 'FETCH_PROCESS_COST_PER_KG_INVOICE_REQUEST';
export const FETCH_PROCESS_COST_PER_KG_INVOICE_SUCCESS = 'FETCH_PROCESS_COST_PER_KG_INVOICE_SUCCESS';
export const FETCH_PROCESS_COST_PER_KG_INVOICE_FAILURE = 'FETCH_PROCESS_COST_PER_KG_INVOICE_FAILURE';

export const RESET_PROCESS_COST_PER_KG_INVOICE = 'RESET_PROCESS_COST_PER_KG_INVOICE';
export const PREVLIST_LOADER_INDICATION_STYLE = 'PREVLIST_LOADER_INDICATION_STYLE';


export const FETCH_CHECK_PROCESS_REQUEST = 'FETCH_CHECK_PROCESS_REQUEST';
export const FETCH_CHECK_PROCESS_SUCCESS = 'FETCH_CHECK_PROCESS_SUCCESS';
export const FETCH_CHECK_PROCESS_FAILURE = 'FETCH_CHECK_PROCESS_FAILURE';



export const FETCH_FABRIC_PROCESS_COST_PER_KG_INVOICE_REQUEST = 'FETCH_FABRIC_PROCESS_COST_PER_KG_INVOICE_REQUEST';
export const FETCH_FABRIC_PROCESS_COST_PER_KG_INVOICE_SUCCESS = 'FETCH_FABRIC_PROCESS_COST_PER_KG_INVOICE_SUCCESS';
export const FETCH_FABRIC_PROCESS_COST_PER_KG_INVOICE_FAILURE = 'FETCH_FABRIC_PROCESS_COST_PER_KG_INVOICE_FAILURE';


export const CHECK_ASSIGN_PROCESS_REQUEST = 'CHECK_ASSIGN_PROCESS_REQUEST';
export const CHECK_ASSIGN_PROCESS_SUCCESS = 'CHECK_ASSIGN_PROCESS_SUCCESS';
export const CHECK_ASSIGN_PROCESS_FAILURE = 'CHECK_ASSIGN_PROCESS_FAILURE';